export { SettingsScreen as default } from '@/src/features/settings/ui/screens/SettingsScreen'
